import React, { Component } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';

export default class BoardMemberEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: false,
            member: {}
        }
    }

    componentDidMount() {
        if(!this.props.createNew) {
            const { id } = this.props.match.params;

            if(id > 0) {
                fetch('/api/boardmembers/' + id, {
                    method: 'GET'
                })
                .then(resp => resp.json())
                .then(data => {
                    if(data.appointmentDate) {
                        data.appointmentDate = data.appointmentDate.substring(0, data.appointmentDate.indexOf('T'));
                    }

                    if(data.expirationDate) {
                        data.expirationDate = data.expirationDate.substring(0, data.expirationDate.indexOf('T'));
                    }

                    if(data.dateRemoved) {
                        data.dateRemoved = data.dateRemoved.substring(0, data.dateRemoved.indexOf('T'));
                    }

                    this.setState({ member: data, editMode: true })
                })
            }
        }
    }

    handleChange = (e) => {
        let { member } = this.state;
        member[e.target.name] = e.target.value;
        this.setState({ member: member });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        if(this.state.editMode) {
            this.saveChanges();
        } else {
            this.createNew();
        }
    }

    saveChanges = () => {
        fetch('api/boardmembers/' + this.props.match.params.id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(this.state.member)
        })
        .then(response => {
            if(response.ok) {
                alert('Your changes have been saved.');
            } else {
                response.json().then(data => alert('The changes were unable to be saved to the database. ' + data));
            }
        })
    }

    createNew = () => {
        let {member} = this.state;
        member.boardId = this.props.boardId;
        member.profileId = this.props.profileId;
        member.isActive = true;

        fetch('/api/boards/GetVacanciesByBoardId/' + this.props.boardId, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
            if(data === 0) {
                alert('The board is already full.  Please edit the board to make space by either removing a current member or increasing the Total Seats on the board.');
            } else {
                fetch('api/boardmembers', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(member)
                })
                .then(response => {
                    if(response.ok) {
                        alert('The board member has been created and is now a part of the board.');
                        this.props.onFinalizeSuccess()
                    } else {
                        alert('There was an error saving the board member.  Please try again at a later time.');
                    }
                })
            }
        }) 
    }

    removeMember = () => {
        const { member } = this.state;
        member.isActive = false;
        let today = new Date()
        member.dateRemoved = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        fetch('api/boardmembers/' + this.props.match.params.id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(member)
        })
        .then(response => {
            if(response.ok) {
                alert(member.profile.firstName + ' ' + member.profile.lastName + ' has been removed from the board.');
                this.props.history.push('/admin/boards/' + member.boardId);
            } else {
                response.json().then(data => alert('The changes were unable to be saved to the database. ' + data));
            }
        })
    }

    render() {
        const { title, position, appointedBy, appointmentDate, comments, dateRemoved, expirationDate, board, profile } = this.state.member;
        const { editMode } = this.state;

        let name, boardName = '';

        if(profile) {
            name = profile.firstName + ' ' + profile.lastName;
        }

        if(board) {
            boardName = board.name;
        }

        return(
            <div>
                {name && boardName && 
                    <h5>{name} - {boardName}</h5>
                }
                
                <Form className='form-border' onSubmit={this.handleSubmit}>
                    <Row>
                        <Col sm='3'>
                            <FormGroup>
                                <Label for='title'>Title</Label>
                                <Input name='title' value={title || ''} onChange={this.handleChange} maxLength={50} />
                            </FormGroup>
                        </Col>
                        <Col sm='3'>
                            <FormGroup>
                                <Label for='position'>Position</Label>
                                <Input name='position' value={position || ''} onChange={this.handleChange} maxLength={100} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm='3'>
                            <FormGroup>
                                <Label for='appointedBy'>Appointed By</Label>
                                <Input name='appointedBy' value={appointedBy || ''} onChange={this.handleChange} maxLength={50} />
                            </FormGroup>
                        </Col>
                        <Col sm='3'>
                            <FormGroup>
                                <Label for='appointmentDate'>Appointment Date</Label>
                                <Input type='date' name='appointmentDate' value={appointmentDate || ''} onChange={this.handleChange} />
                            </FormGroup>
                        </Col>
                        <Col sm='3'>
                            <FormGroup>
                                <Label for='expirationDate'>Expiration Date</Label>
                                <Input type='date' name='expirationDate' value={expirationDate || ''} onChange={this.handleChange} />
                            </FormGroup>
                        </Col>
                        <Col sm='3'>
                            <FormGroup>
                                <Label for='dateRemoved'>Date Removed</Label>
                                <Input type='date' name='dateRemoved' disabled value={dateRemoved || ''} onChange={this.handleChange} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm='12'>
                            <FormGroup>
                                <Label for='comments'>Comments</Label>
                                <Input type='textarea' name='comments' value={comments || ''} onChange={this.handleChange} maxLength={1000} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button type='submit'>Submit</Button>
                    {editMode &&
                        <Button className='ml-2' onClick={this.removeMember}>Remove Member from Board</Button>
                    }
                </Form>
            </div>
        )
    }
}